module.exports = __webpack_public_path__ + "img/google-plus.be19e82c.svg";